/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Payment } from '@app/finance/payments/payment.model';

export class BankStatement extends Model {
  id: number;
  payments: Array<Payment>;
  meta_front?: any;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.payments) {
      this.payments = input.payments.map((payments: Payment) => new Payment().deserialize(payments));
    }

    return this;
  }
}
